import { render, staticRenderFns } from "./c_Creator_Events_Item_GameStatus.vue?vue&type=template&id=71391b6c&scoped=true&"
import script from "./c_Creator_Events_Item_GameStatus.vue?vue&type=script&lang=js&"
export * from "./c_Creator_Events_Item_GameStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71391b6c",
  null
  
)

export default component.exports